(function () {
  function init() {
    if (!window.vvLazyAutoplayObserver) {
      window.vvLazyAutoplayObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var video = entry.target;
          window.vvLazyAutoplayObserver.unobserve(video);
          video.preload = 'auto';
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        });
      }, { rootMargin: '200px 0px' });
    }
    document.querySelectorAll('.vv-lazy-autoplay-video:not([data-vv-observed])').forEach(function (video) {
      video.setAttribute('data-vv-observed', 'true');
      window.vvLazyAutoplayObserver.observe(video);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
